<template>
    <div class="user-table-container">
        <div class="HeaderTab">
             <el-button v-for="item in Child" :key="item.id" size="small" :type="SysType != item.id?'info':'primary'" plain @click="ToggleSysType(item.id)">{{item.system_name}}</el-button>
        </div>
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="TypeVal" @change="ReSetPage" clearable placeholder="申请类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="warning" @click="AuditAll">批量审核</el-button>
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <!-- <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="warning" @click="DownAll">批量下载</el-button> -->
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">申请</el-button>
                <!-- <el-button v-throttle size="small" type="primary" @click="SeleUser('File')">导入</el-button> -->
                <!-- <el-button v-throttle size="small" type="primary" @click="SeleUser('DownMol')">下载模板</el-button> -->
                <!-- <el-dropdown trigger="click" @command="SeleUser">
                    <el-button v-throttle size="small" type="primary" icon="el-icon-more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="DownMol">下载模板</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="SeleChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="group_name" label="申请类型" min-width="100"></el-table-column>
            <el-table-column prop="record_name" label="标题" min-width="100"></el-table-column>
            <el-table-column prop="user_name" label="申请人" min-width="100"></el-table-column>
            <el-table-column prop="sq_status_name" label="状态" min-width="100">
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.sq_status_name}}</el-tag>
                    <el-button class="MarLt" type="text" size="mini" @click="OpenMsg(scope.row.reject_reason)" v-if="scope.row.reject_reason">查看驳回原因</el-button>
                    <el-button class="MarLt" type="text" size="mini" @click="OpenMsg(scope.row.online_shenhe_opinion)" v-if="scope.row.is_online_shenhe==3">查看驳回原因</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="提交时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="审核" placement="top-start">
                        <i class="NavIcon el-icon-s-check" @click="ToggleAudit(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="审核建议" placement="top-start">
                        <i class="NavIcon el-icon-notebook-2" @click="ToggleRule(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="收集信息查看" placement="top-start">
                        <i class="NavIcon el-icon-view" @click="LockData(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">                        
                        <i class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        
                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                    </el-tooltip>
                    <el-popover placement="top" width="100">
                        <div>
                            <div class="TongBuDis JusRight">
                                <el-button type="primary" plain size="mini" @click="LockUserPs(scope.row)">预览</el-button>
                            </div>
                            <div class="TongBuDis">
                                <span>形式审查意见</span> 
                                <el-switch v-model="scope.row.is_xingshi_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                        </div>
                        <div slot="reference" class="TongBuBtn">
                          <el-tooltip effect="dark" content="意见同步客户" placement="top-start">
                              <i class="NavIcon el-icon-s-promotion"></i>
                          </el-tooltip>
                        </div>
                    </el-popover>
                    <el-tooltip effect="dark" content="下载" placement="top-start">
                        <i class="NavIcon el-icon-download" @click="DownFile(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <FieldMol 
        :visible="NewData.NewBlon" 
        :BaoCun="false" 
        :Type="Type" 
        :rowData="RowData" 
        :newData="NewData" 
        :rowtype="RowType"
        :sysType="SysType"
        @cancel="$Tools.ResetData(NewData)" 
        @submit="SucData"/>
        <AuditMolDig :visible="RuleData.RuleBlon" :itemList="RuleList" :Type="ShowType" @cancel="$Tools.ResetData(RuleData)" @submit="SucRule" />
        <PingShenUser :visible="UserPSBlon" :rowData="UserPSData" @cancel="UserPSBlon = false" />
        <el-dialog title="分配审核专家" :visible.sync="AuditData.AuditBlon" width="45%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">是否通过：</div>
                <el-radio-group v-model="AuditData.AuditVal" @click="AuditChange">
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="2">不通过</el-radio>
                </el-radio-group>
            </div>
            <div class="DigItem" v-if="AuditData.AuditVal==2">
                <div class="DigItemTit">驳回原因：</div>
                <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入内容" v-model="AuditData.AuditRemark"> </el-input>
            </div>
            <template  v-if="AuditData.AuditVal==1">
                <div class="DigItem BorTop">
                    <div class="DigItemTit">审核时间：</div>
                    <el-input class="Wid" size="medium" v-model="AuditData.AuditTime" placeholder="请输入审核时间（小时）" ></el-input>
                    单位（小时）
                </div>
                <div class="DigItem BorTop">
                    <div class="DigItemTit">审核组：</div>
                    <div>
                        <div class="DigItem" v-for="(item,i) in AuditData.AuditDataUser" :key="i">
                            <div>组别：</div>
                            <el-select class="DigWid" size="medium" v-model="item.zid" placeholder="请选择分组" @change="(res)=>{GetGroupUser(res,item)}">
                                <el-option v-for="item in GroupList" :key="item.id" :label="item.group_name" :value="item.id"></el-option>
                            </el-select>
                            <template>
                                <div class="DigPad">组长：</div>
                                <el-select class="DigWid" collapse-tags size="medium" v-model="item.zuzhang" clearable placeholder="请选择组长">
                                    <el-option v-for="i in item.zuyuan" :key="i.id" :label="i.name" :value="i.id"></el-option>
                                </el-select>
                                <div class="DigPad">审核人：</div>
                                <el-select class="DigWid" collapse-tags size="medium" v-model="item.userlist" clearable multiple placeholder="默认整组成员">
                                    <el-option v-for="i in item.zuyuan" :key="i.id" :label="i.name" :value="i.id"></el-option>
                                </el-select>
                            </template>
                            <i v-if="i!=0" class="el-icon-delete UserDel" @click="DelAudit(i)"></i>
                        </div>
                    </div>
                    <el-button v-throttle class="MarLt" size="small" type="primary" @click="AddAudit()">新增</el-button>
                </div>
                <div class="DigItem BorTop">
                    <div class="DigItemTit">形审意见：</div>
                    <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入内容" v-model="AuditData.AuditRemark"> </el-input>
                </div>
            </template>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(AuditData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="AuditSuc">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="DownData.Type=='Down'?'下载模板':'导入'" :visible.sync="DownData.Blon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">类型：</div>
                <el-select class="Wid120" size="medium" v-model="DownData.Id" clearable placeholder="类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
            </div>
            <div slot="footer">
                <div class="footer">
                    <el-button v-throttle size="small" @click="$Tools.ResetData(DownData)">取消</el-button>
                    <el-button v-if="DownData.Type =='Down'" v-throttle class="BgColor" size="small" type="primary" @click="DownSuc">确定</el-button>
                    <el-upload class="MarLt" v-else action="none" :show-file-list="false" :http-request="UploadFlie">
                        <el-button v-throttle size="small" type="primary">确定</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                visible:false,
                loading:false,
                SysType:"",
                SearchVal:"",
                TypeVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                SeleId:[],
                Type:'Edi',
                ShowType:"1",
                NewData:{
                    id:'',
                    NewBlon:false,
                    record_name:"",
                },
                RowType:[],
                RowData:{
                    group: [],
                    gl_file: [],
                },
                GroupList:"",
                SeleAudit:false,
                AuditData:{
                    id:"",
                    AuditBlon:false,
                    AuditVal:"1",
                    AuditRemark:"",
                    AuditTime:"",
                    AuditDataUser:[],
                },
                RuleList:[],
                RuleData:{
                    id:"",
                    RuleBlon:false,
                },
                DownData:{
                    Blon:false,
                    Type:"Down",
                    Id:"",
                },
                UserPSData:{},//评审数据
                UserPSBlon:false,
            };
        },
        props: ['ApiType','Child'],
        mounted() {
            this.SysType = this.Child[0].id.toString();
            this.GetData();
            this.GetTypeList();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/record/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                    group_id:this.TypeVal,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetGroup(){
                this.$get('/admin/expert_group/getAll').then(res=>{
                    if(res){
                        this.GroupList = res.data;
                    }
                })
            },
            GetGroupUser(id,row){
                this.$get('/admin/expert_group/detail',{
                    id:id
                }).then(res=>{
                    if(res){
                        row.userlist = [];
                        row.zuzhang = "";
                        row.zuyuan = res.data.experts;
                    }
                })
            },
            GetTypeList(){
                this.$get('/admin/record/allData',{
                    SystemCode:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetRuleList(id){
                this.$get('/admin/record/gradedata',{
                    system_code:this.ApiType,
                    id:id,
                }).then(res=>{
                    if(res){
                        this.RuleList=res.data.map(i=>{
                            if(i.text_content){i.text_content = JSON.parse(i.text_content)}
                            return i;
                        });
                        this.RuleData.RuleBlon = true;
                    }
                })
            },
            GetDetail(id){
                this.$get('/admin/record/detail',{
                    id:id,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                        this.NewData.NewBlon = true;
                    }
                })
            },
            SeleUser(type){
                if(type == "DownMol"){
                    this.DownData.Type = "Down";
                };
                if(type == "File"){
                    this.DownData.Type = "File";
                };
                this.DownData.Blon = true;
                this.DownData.Id = ""; 
            },
            LockData(row){
                this.Type= "Lock";
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type="Edi";
                    this.NewData.id = row.id;
                    this.NewData.record_name = row.record_name;
                    this.GetDetail(row.id)
                }else{
                    this.Type='Add';
                    this.RowData={
                        group: [],
                        gl_file: [],
                    };
                }
                this.NewData.NewBlon = true;
            },
            SucData(q,n){
                this.$confirm("确定是否"+(n?'提交':'保存')+"?", "提示", {
                    type: "warning"
                }).then(() => {
                   var url = '/admin/record/add';
                   if(this.Type!='Add'){
                       url = '/admin/record/update';
                   }
                   q.SystemCode = this.ApiType;
                   this.$post(url,q).then(res=>{
                       if(res){
                           this.$message.success(res.msg);
                           this.GetData();
                           this.$Tools.ResetData(this.NewData)
                       }
                   })
                })
            },
            ToggleRule(row){
                this.ShowType = row.is_yijian.toString();
                this.RuleData.id = row.id;
                this.GetRuleList(row.id)
            },
            SucRule(data){
                var Arr = [];
                data.forEach(i=>{
                    Arr.push({
                        id:i.id,
                        gl_yj:i.gl_yj,
                    })
                });
                this.$post('/admin/record/grade',{
                    id:this.RuleData.id,
                    data:Arr,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.RuleData)
                    }
                })
            },
            AuditAll(){
                this.AuditData.id ="";
                this.GetGroup();
                this.AuditData.AuditBlon = true;
                this.AuditData.AuditTime = 72;
                this.AuditData.AuditDataUser = [{zid:"",zuzhang: '',userlist:[],zuyuan:[]}];
            },
            ToggleAudit(row){
                this.GetGroup();
                this.AuditData.id = row.id;
                this.AuditData.AuditTime = row.review_hours;
                this.AuditData.AuditBlon = true;
                this.AuditData.AuditDataUser = [{zid:"",zuzhang: '',userlist:[],zuyuan:[]}];
            },
            AuditChange(){
                if(this.AuditData.AuditVal == 1){
                    this.AuditData.AuditDataUser = [{zid:"",zuzhang: '',userlist:[],zuyuan:[]}];
                }
            },
            AddAudit(type){
                this.AuditData.AuditDataUser.push({zid:"",zuzhang: '',userlist:[],zuyuan:[]});
            },
            DelAudit(index){
                this.AuditData.AuditDataUser.splice(index,1);
            },
            AuditSuc(){
                if(this.AuditData.AuditVal==2){
                    this.BohuiSuc();
                }else{
                    this.TongguoSuc();
                }
            },
            BohuiSuc(){
                var Ids = this.AuditData.id?[this.AuditData.id]:this.SeleId;
                this.$post('/admin/record/pass',{
                    id:Ids,
                    reject_reason:this.AuditData.AuditRemark,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.AuditData)
                    }
                })
            },
            TongguoSuc(){
                var Ids = this.AuditData.id?[this.AuditData.id]:this.SeleId;
                this.$post('/admin/record/agree',{
                    id:Ids,
                    zhuanjia1:this.AuditData.AuditDataUser,
                    opinion:this.AuditData.AuditRemark,
                    online_review_time:this.AuditData.AuditTime,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.AuditData)
                    }
                })
            },
            ToggleTongBu(row){
                this.$post('/admin/record/userkai',{
                    id:row.id,
                    is_xingshi_user_yj:row.is_xingshi_user_yj,
                    is_online_user_yj:row.is_online_user_yj,
                    is_final_user_yj:row.is_final_user_yj,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                    }
                })
            },
            SeleChange(val){
                this.SeleId = val.map(item => item.id);
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/record/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            DownSuc(){
                if(this.DownData.Type == "Down"){
                    this.DownMol();
                }
                this.$Tools.ResetData(this.DownData)
            },
            DownFile(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/record/export',{
                        id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            UploadFlie(res){
                var file = res.file;
                if (this.$Tools.ChangeExcel(file)) {
                    this.$message.error('只能上传Excel文件格式 (.xls, .xlsx, .xlsm, .xlsb)');
                    return false;
                }
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    fd.append('SystemCode',this.ApiType);
                    fd.append('system_sub_id',this.SysType);
                    fd.append('group_id',this.DownData.Id);
                    this.$post("/admin/record/daoru",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.$message.success(res.msg);
                        this.GetData();
                    }).catch((res)=>{
                        loading.close();
                    })
                    
                } catch (error) {
                    loading.close();
                }
                this.$Tools.ResetData(this.DownData)
            },
            DownMol(){
               this.$get('/admin/record/moban',{
                   SystemCode:this.ApiType,
                   group_id:this.DownData.Id,
                   system_sub_id:this.SysType,
               }).then(res=>{
                   if(res){
                       this.$message.success(res.msg);
                       window.open(res.data.download_url)
                   }
               })
            },
            OpenMsg(msg){
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            },
            LockUserPs(row){
                this.$get('/admin/record/shenhe',{
                    id:row.id,
                    system_code:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.UserPSBlon = true;
                        this.UserPSData = res.data;
                    }
                })
            },
            ToggleSysType(id){
                this.SysType = id;
                this.ReSetPage();
                this.GetTypeList();
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
            LockUrl(url){
                window.open(this.$Tools.ServeUrl()+url)
            },
        }
    };
</script>

<style scoped>
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .DisFlex{
        display: flex;
        align-items: center;
    }
    .BtnHead{
        gap:0;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianAbs{
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .DigWid{
        width: 150px;
    }
    .DigPad{
        padding-left: 10px;
    }
    .BorTop{
        border-top:1px solid #ddd;
        padding-top: 10px;
    }
    .MarLt{
        margin-left: 10px;
    }
    .UserDel{
        color: #f56c6c; 
        cursor: pointer;
    }
    .TableBg{
        background: #dcdcdc;
    }
    .TablePad{
        padding: 10px 0;
        font-weight: 700;
    }
    .Wid30{
        width: 35%;
    }
    .Wid70{
        width: 65%;
    }
    .TableNum{
        padding-bottom: 10px;
        font-weight: 700;
    }
    .DigTable{
        border: 1px solid #028b8b;
        margin-bottom: 10px;
    }
    .DigTableTop{
        display: flex;
        border-bottom: 1px solid #028b8b;
    }
    .DigTableHead{
        border-bottom: 1px solid #028b8b;
    }
    .DigTableDis{
        display: flex;
    }
    .ItemDis{
        display: flex;
        align-items: center;
    }
    .DigTableBor{
        text-align: center;
        border-right: 1px solid #028b8b;
    }
    .DigTableBor:last-child{
        border: 0;
    }
    .ItemTit{
        width: 130px;
        font-weight: 500;
        font-size: 18px;
        padding: 5px;
    }
    .ItemFuTit{
        flex: 1;
        padding: 5px;
        border-left: 1px solid #028b8b;
        text-align: center;
    }
    .ItemQz{
        padding-top: 5px;
    }
    .ItemRadio{
        height: 50%;
    }
    .ItemRadio .Radio{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .RadioCer{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .RadioCer input{
        margin-top: 0;
    }
    .ItemRadio .Radio::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemRadioMsg{
        height: 50%;
        border-top: 1px solid #028b8b;
    }
    .ItemRadioMsg .ItemRadioMsgDom{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .ItemRadioMsg .ItemRadioMsgDom::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemMsg{
        padding: 5px;
        border-top: 1px solid #028b8b;
    }
    .ItemRadio .Radio:last-child::after,
    .ItemRadioMsg .ItemRadioMsgDom:last-child::after,
    .DigTableHead:last-child{
        border: 0;
    }
    .footer{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .TongBuDis{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    .JusRight{
        justify-content: flex-end;
    }
    .TongBuBtn{
        display: inline-block;
    }
</style>
